import { COMMAND_CENTER_ROOT } from './commandCenterRoutes'
import { useParams, useNavigate } from 'react-router-dom'
import { RoleDetail, TEAM_ROOT } from './comms'

/**
 * V2 Team role detail — route wrapper.
 *   /square/command-center/team/roles/:roleId
 *
 * Custom team roles are DEFERRED (v1 uses a fixed role enum). RoleDetail says
 * so honestly — no fabricated roles catalogue.
 */
export default function SquareCodeTeamRoleRoute() {
  const { roleId } = useParams<{ roleId: string }>()
  const navigate = useNavigate()
  return (
    <RoleDetail
      roleId={roleId}
      onHome={() => navigate(COMMAND_CENTER_ROOT)}
      onBackCommandCenter={() => navigate(COMMAND_CENTER_ROOT)}
      onBackTeam={() => navigate(TEAM_ROOT)}
      onNavTop={(to) => navigate(to)}
    />
  )
}
